import { Injectable } from '@angular/core';
import { Observable, throwError, ReplaySubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { User } from '../../shared/models/user';
import { CoreLib } from '../../shared/models/core-lib';


declare var core: CoreLib;
declare var baseApiUrl: string;

@Injectable({
  providedIn: 'root'
})
export class UserServiceService {


  constructor(private http: HttpClient) {
  }

  getLastLogin(): Observable<string> {
    var requestUrl = `${baseApiUrl}/users/last-login`;

    return this.http.get<string>(requestUrl)
      .pipe(
        map((res: string) => { return res; }),
        catchError((httpError: HttpErrorResponse) => this.handleError(httpError))
      );
  }

  syncUsers(): Observable<User[]> {
    var requestUrl = `${baseApiUrl}/users/sync`;

    return this.http.get<User[]>(requestUrl)
      .pipe(
        map((res: User[]) => { return res; }),
        catchError((httpError: HttpErrorResponse) => this.handleError(httpError))
      );
  }

  handleError(httpError: HttpErrorResponse): Observable<never> {
    var errorMessage = "An unknown error occurred while submitting the request";

    if (httpError.error && httpError.error.message) {
      errorMessage = httpError.error.message;
    }

    core.pageBanner.loadResponse(errorMessage, { title: "Error occurred", type: core.pageBanner.bannerTypes.error });

    return throwError(httpError);

  }
}
